module.exports = __webpack_public_path__ + "static/img/home1.9334f97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/home1.jpg
// module id = h661
// module chunks = 0